import { useEffect } from 'react'
import { updateTwitterBind } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'
import { Status } from 'state/interfaces'

import { agent } from '../api/agent'

export const useTwitterAuth = (account?: string, isConfirmed?: boolean) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (account) {
      dispatch(updateTwitterBind({ isBound: false, status: Status.PENDING, account }))
      try {
        agent.competition.isRegistered(account).then(({ registered }) => {
          dispatch(updateTwitterBind({ isBound: registered, status: Status.SUCCESS, account }))
        })
      } catch (e) {
        dispatch(updateTwitterBind({ isBound: false, status: Status.ERROR, account }))
      }
    }
  }, [account, isConfirmed])
}
